module.exports = __webpack_public_path__ + "static/dsmhack-cd710a6a3694965e91df5b7b24046b42.png";